import React from 'react'
import {PaymentMethodContainer, PaymentMethodIframeContainer} from './styles'
import {SettingsBox} from '../../../../pages/Settings/styles'
import Breadcrumb, {
  BreadcrumbType,
} from '../../../../new-dashboard/components/Breadcrumb'

const View = () => {
  const breadcrumbs: BreadcrumbType[] = [
    {
      title: 'Payment Method',
      url: '#',
    },
  ]

  return (
    <>
      <Breadcrumb breadcrumbs={breadcrumbs} />
      <SettingsBox>
        <PaymentMethodContainer>
          <PaymentMethodIframeContainer
            id="billing-widget-iframe"
            src={process.env.REACT_APP_UPDATE_PAYMENT_METHOD_URL}
          ></PaymentMethodIframeContainer>
        </PaymentMethodContainer>
      </SettingsBox>
    </>
  )
}

export default View
